import React from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  InfoDropdown,
  NewDatePickerField,
  NewSelectField,
  NewTextInputField,
} from '@edna/components';
import {Label} from '@edna/components/FormField';

import {MIN_CALENDAR_DATE} from 'src/constants';
import {EAgentClientSigningBasis, TAgentFormData} from 'src/containers/LeadCompanyClients';

export const SigningBasisFields = React.memo(() => {
  const {t} = useTranslation();

  const {watch, setValue} = useFormContext<TAgentFormData>();
  const signingBasis = watch('signingBasis');

  const handleChange = React.useCallback(() => {
    setValue('signingBasisNumber', '');
    setValue('signingBasisDate', null);
  }, [signingBasis]);

  const signingBasisOptions = React.useMemo(() => {
    const options = Object.values(EAgentClientSigningBasis).map((basis) => ({
      value: basis,
      label: t(`AgentCompanyClients:signingBasis.${basis}`),
    }));

    return options;
  }, [t]);

  return (
    <>
      <Label htmlFor="signingBasis">{t('AgentCompanyClients:createForm.signingBasis')}</Label>
      <NewSelectField
        name="signingBasis"
        options={signingBasisOptions}
        onChange={handleChange}
        placeholder={t('AgentCompanyClients:createForm.selectSigningBasis')}
      />
      {!!signingBasis && signingBasis !== EAgentClientSigningBasis.CHARTER && (
        <>
          <Label htmlFor="signingBasisNumber">
            {t('AgentCompanyClients:createForm.signingBasisNumber')}
            {signingBasis === EAgentClientSigningBasis.CERTIFICATE && (
              <InfoDropdown
                hasMarginLeft
                size="S"
                content={t('AgentCompanyClients:createForm.certificateHint')}
              />
            )}
          </Label>
          <NewTextInputField name="signingBasisNumber" />
          <Label htmlFor="signingBasisDate">
            {t('AgentCompanyClients:createForm.signingBasisDate')}
          </Label>
          <NewDatePickerField name="signingBasisDate" width="100%" minDate={MIN_CALENDAR_DATE} />
        </>
      )}
    </>
  );
});

SigningBasisFields.displayName = 'SigningBasisFields';
